import { UserIsAuthenticated } from '../../common/services/AuthenticationRules';
import HomePage from './component';

export default UserIsAuthenticated(HomePage);
